import { render, staticRenderFns } from "./ModalFormExCategory.vue?vue&type=template&id=2638da4a&scoped=true&"
import script from "./ModalFormExCategory.vue?vue&type=script&lang=js&"
export * from "./ModalFormExCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2638da4a",
  null
  
)

export default component.exports